/* eslint-disable padding-line-between-statements */
import { Loader, ModalHeader, ModalNext, ModalBody, ModalFooter,  formatCurrency} from '@jutro/components';
import { Button } from '@jutro/legacy/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator, IntlContext } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import PropTypes, { string } from 'prop-types';
import React, {
    useCallback,
    useContext,
    // useEffect,
    useState,
} from 'react';
import metadata from './ConfirmationPopup.metadata.json5';
import styles from './ConfirmationPopup.module.scss';
import messages from './ConfirmationPopup.messages';


function ConfirmationPopup(props) {
    const {
        paymentDetails,
        currency,
        policyData, // US25428 - new Offers
        isOpen,
        onResolve,
        // onReject,
        onAfterClose,
        onClickOk,
        payFrom
    } = props;
   
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, /* setIsLoading */] = useState(false);
    const translator = useTranslator();
    const intlContext = useContext(IntlContext);
    const clickOK = useCallback(() => {
    // 2025-01-20 - Debra Frum - US25428 - CE - Offer Bind and Confirmation
    // Pass policy data for new Offers to display the Submission Successful page
    if (payFrom === "offers" ) {
        onClickOk(policyData);
    } else {
        onClickOk();
    }
    onResolve();
    }, [onClickOk, onResolve, payFrom, policyData])


    const curAmt =((amount )=>{
        const curProps = {
            currencyDisplay: string,
            showFractions: true
            
        }
        return formatCurrency(
            intlContext,
            curProps,
            { amount, currency }) 
    })
   
    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        paymentSubmittedSuccessfullyId: {
            content : translator(messages.paymentSubmittedSuccessfully)
        },
        confirmationId: {
            content: translator(messages.confirmation, {confirmationNumber: paymentDetails.confirmationNumber}),
        },
        premiumPaymentId: {
            content: translator(messages.premiumPayment, {amount: curAmt((paymentDetails.amount)?.toFixed(2))})
        },
        vendorServiceFeeId:{
            content: translator(messages.vendorServiceFee, {feeAmount: curAmt((paymentDetails.feeAmount)?.toFixed(2))})
        },
        totalPaymentId: {
            content: translator(messages.totalPayment, {amount: curAmt((paymentDetails.amount + paymentDetails.feeAmount)?.toFixed(2))})
        }
      
    };

    const resolvers = {
        resolveCallbackMap: {
            // onClickOk
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext  isOpen={isOpen}  onAfterClose={onAfterClose}>
            <ModalHeader title={translator(messages.paymentConfirmation)} />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={paymentDetails}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
            <ModalFooter>
                 <Button onClick={clickOK} type="outlined"> {translator(messages.ok)} </Button>            
            </ModalFooter>
        </ModalNext>
    )
}

ConfirmationPopup.propTypes = {
    isOpen: PropTypes.bool,
    onResolve: PropTypes.func,
    onReject: PropTypes.func,
    onAfterClose: PropTypes.func,
};

ConfirmationPopup.defaultProps = {
    onAfterClose: _.noop,
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop
};

export default ConfirmationPopup;
